import React, { useEffect } from 'react'
import { useLocation, useParams, useSearchParams } from 'react-router-dom'
import { useState } from 'react'
import Agree from './Agree'
import BarLoader from 'react-spinners/BarLoader'
import ShareBtn from '../ShareBtn'

function Layout({ setCompletionMessage }) {
  const [ac, setAc] = useState(null)
  const [tk, setTk] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [showShareBtn, setShowShareBtn] = useState(true)

  // 特殊設定
  // const { pathname } = useLocation()
  // const pid = pathname
  //   .split('/')
  //   .filter((segment) => segment)[0]
  //   .toUpperCase()

  // const { serial_num } = useParams()
  // const pid = 'P250528175251672'
  // const { uid } = useParams()
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const [pid, setPid] = useState(location.pathname.split('/')[1].toUpperCase())
  const [serialNum, setSerialNum] = useState(
    searchParams.get('serial_num') || null
  )
  const [uid, setUid] = useState(searchParams.get('user_id') || null)

  useEffect(() => {
    // 從路徑中提取 pid
    const newPid = location.pathname.split('/')[1].toUpperCase()
    setPid(newPid)

    // 獲取查詢參數
    const nweSerialNum = searchParams.get('serial_num')
    setSerialNum(nweSerialNum)
    const newUserId = searchParams.get('user_id')
    setUid(newUserId)

    console.log('Project ID:', pid)
    console.log('Serial Number:', serialNum)
    console.log('User ID:', newUserId)
  }, [searchParams, location.pathname])

  // pid = 'P' + pid.split('/p')[1]
  // const pid = 'P231206105643'
  // 隨機一份問卷
  // const pidObj = {
  //   0: 'P230919184319',
  //   1: 'P230815121716',
  //   2: 'P230815121714',
  // }

  // const [randomPid, setrandomPid] = useState('')
  // useEffect(() => {
  //   const ord = Math.floor(Math.random() * 3)
  //   setrandomPid(pidObj[ord])
  // }, [])
  // console.log('randomPid', randomPid)

  // BarLoader
  const actualInnerWidth = document.body.clientWidth - 20
  // share
  // const shareUrl = `${window.location.origin}/${pid}`

  return (
    <>
      <BarLoader
        cssOverride={{ overflow: 'hidden', position: 'fixed', zIndex: '1021' }}
        color="#19b394"
        width={actualInnerWidth}
        loading={isLoading}
      />

      <Agree
        setIsLoading={setIsLoading}
        pid={pid}
        setAc={setAc}
        setTk={setTk}
        ac={ac}
        tk={tk}
        setShowShareBtn={setShowShareBtn}
        setCompletionMessage={setCompletionMessage}
        userId={uid}
      />
      {/* <ShareBtn showShareBtn={showShareBtn} shareUrl={shareUrl} /> */}
    </>
  )
}

export default Layout
